import React, { useRef, useState } from 'react';
import { UsuarioService } from "@services";
import { LoginEntidade } from "@entidades";
import { Alert, Box, Button, Form, Input } from '@intech/web-ui';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { MasterPage } from '@components';
import { NumFuncionalidade } from '@src/helpers/BloqueioFuncionalidade';
import { DMN_ORIGEM_SISTEMA } from '@domains';

export const TrocarSenha: React.FC = (props) => {
  const form = useRef<Form>(null);

  const [AlertType, setAlertType] = useState<"success" | "danger" | "warning" | "info">("danger");
  const [AlertText, setAlertText] = useState<string>("");
  const [SenhaAntiga, setSenhaAntiga] = useState<string>("");
  const [SenhaNova, setSenhaNova] = useState<string>("");
  const [ConfirmarSenha, setConfirmarSenha] = useState<string>("");

  const [senhaAntigaVisivel, setsenhaAntigaVisivel] = useState(false);
  const [senhaNovaVisivel, setsenhaNovaVisivel] = useState(false);
  const [senhaConfirmarVisivel, setsenhaConfirmarVisivel] = useState(false);

  async function TrocarSenha() {
    try {
      // Valida se os campos de nova senha e confirmação são iguais.
      if (SenhaNova !== ConfirmarSenha) {
        setAlertType("danger");
        setAlertText("As senhas não coincidem.");
        return null;
      }

      if (form?.current?.validate()) {

        let le = new LoginEntidade();
        le.SenhaAntiga = SenhaAntiga;
        le.SenhaNova = SenhaNova;
        le.Origem = DMN_ORIGEM_SISTEMA.PORTAL;

        const res = await UsuarioService.AlterarSenha(le);

        setAlertText(res);
        setAlertType("info");

        setSenhaAntiga("");
        setSenhaNova("");
        setConfirmarSenha("");
      }
    }
    catch (e) {
      setAlertType("danger");
      const error = e.response ? e.response.data : e;
      setAlertText(error);
    }
  }

  return (
    <MasterPage {...props} Funcionalidade={NumFuncionalidade.TROCAR_SENHA}>
      <Box>
        <Alert type={"danger"}>
          {"A senha deve conter pelo menos 6 caracteres e um número (0-9)."}
        </Alert>

        <Form ref={form}>
          <Input
            title={"Senha atual"}
            value={SenhaAntiga}
            onChange={setSenhaAntiga}
            type={senhaAntigaVisivel ? 'text' : 'password'}
            icon={senhaAntigaVisivel ? <FaEyeSlash /> : <FaEye />}
            buttonLeft={false}
            group
            onButtonClick={() => setsenhaAntigaVisivel(old => !old)}
            required
          />

          <Input
            title={"Nova senha"}
            value={SenhaNova}
            onChange={setSenhaNova}
            type={senhaNovaVisivel ? 'text' : 'password'}
            icon={senhaNovaVisivel ? <FaEyeSlash /> : <FaEye />}
            buttonLeft={false}
            group
            onButtonClick={() => setsenhaNovaVisivel(old => !old)}
            required
          />

          <Input
            title={"Confirme nova senha"}
            value={ConfirmarSenha}
            onChange={setConfirmarSenha}
            type={senhaConfirmarVisivel ? 'text' : 'password'}
            icon={senhaConfirmarVisivel ? <FaEyeSlash /> : <FaEye />}
            buttonLeft={false}
            group
            onButtonClick={() => setsenhaConfirmarVisivel(old => !old)}
            required
          />

          <Alert formAlert type={AlertType} />
          {AlertText !== "" && <Alert type={AlertType}>
            {AlertText}
          </Alert>}

          <Button
            onClick={TrocarSenha}
            title={"Trocar Senha"}
            type={"primary"}
            usesLoading
            loadingText={"Enviando..."}
            submit
          />
        </Form>
      </Box>
    </MasterPage>
  );
}
